var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconToggleLive = function SvgIconToggleLive(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29.079,
    height: 18.372,
    viewBox: "0 0 29.079 18.372",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("g", {
    id: "icon-toggle-live",
    transform: "translate(-1333.581 -673.222)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_12119",
    "data-name": "Group 12119",
    transform: "translate(1333.581 673.222)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_30-2",
    "data-name": "Rectangle 30-2",
    width: 29.079,
    height: 18.372,
    rx: 4.769,
    fill: "#ff196e"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "LIVE_TEXT",
    "data-name": "LIVE TEXT",
    transform: "translate(1339.897 676.061)",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12120",
    "data-name": "Group 12120",
    transform: "translate(1.411)",
    style: {
      isolation: "isolate"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1269",
    "data-name": "Path 1269",
    d: "M1346.98,683.847l1.205-5.7h.925l-1.038,4.9h2.1l-.168.8Z",
    transform: "translate(-1346.98 -678.144)",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1270",
    "data-name": "Path 1270",
    d: "M1353.853,683.847l1.213-5.7h.917l-1.214,5.7Z",
    transform: "translate(-1349.889 -678.144)",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1271",
    "data-name": "Path 1271",
    d: "M1360,682.879q.273-.694.535-1.2l1.775-3.53h.991l-2.98,5.7h-1.006l-.562-5.7h.9l.289,3.53c.023.268.038.571.043.909l0,.3Z",
    transform: "translate(-1351.961 -678.144)",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1272",
    "data-name": "Path 1272",
    d: "M1368.873,683.847h-3.027l1.205-5.7h3.027l-.168.8h-2.1l-.328,1.54h1.958l-.16.792h-1.966l-.375,1.779h2.1Z",
    transform: "translate(-1354.965 -678.144)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12121",
    "data-name": "Group 12121",
    transform: "translate(0 6.991)",
    style: {
      isolation: "isolate"
    }
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1273",
    "data-name": "Path 1273",
    d: "M1345.906,695.969h-.924l1.03-4.9h-1.479l.176-.8h3.893l-.168.8h-1.486Z",
    transform: "translate(-1344.533 -690.266)",
    fill: "#fff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1274",
    "data-name": "Path 1274",
    d: "M1353.966,695.969h-3.028l1.205-5.7h3.027l-.168.8h-2.1l-.328,1.541h1.959l-.16.792H1352.4l-.374,1.779h2.1Z",
    transform: "translate(-1347.244 -690.266)",
    fill: "#fff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1275",
    "data-name": "Path 1275",
    d: "M1361.489,695.969h-1l-.749-2.309-1.708,2.309H1357l2.286-3-.976-2.7h.96l.694,2.106,1.568-2.106h1.037l-2.149,2.769Z",
    transform: "translate(-1349.809 -690.266)",
    fill: "#fff"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1276",
    "data-name": "Path 1276",
    d: "M1368.1,695.969h-.924l1.029-4.9h-1.478l.175-.8h3.893l-.168.8h-1.486Z",
    transform: "translate(-1353.926 -690.266)",
    fill: "#fff"
  }))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconToggleLive, _extends({
    svgRef: ref
  }, props));
});
export default "data:image/svg+xml;base64,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";
export { ForwardRef as ReactComponent };